/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import {
  FaTimes, FaCheck, FaEraser,
} from 'react-icons/fa';
import PropTypes from 'prop-types';
import useTranslation from '../../hooks/useTranslation';
import EpButton from '../EpButton';
import EpModalStick from '../EpModalStick';
import './styles.scss';
// import useForm from '../../hooks/useForm';

const EpModalStickColumns = ({
  bodyContent, headerContent, footerContent, modalStickId, buttonToggleId,
}) => {
  // Tags do Globalization
  const Close = useTranslation('Close');
  const Clear = useTranslation('Clear');
  const Run = useTranslation('Run');
  const Columns = useTranslation('Columns');

  const footerContentSm = (
    <>
      <EpButton
        actionType="button"
        labelText={Close}
        data-bs-dismiss="modal"
        buttonType="secondary-outline"
        customClass="btn__footer--close"
        buttonIcon={<FaTimes className="btn__icon" />}
        disabled={false}
      />
      <div className="modal-stick__content-footer-buttons">
        <EpButton
          actionType="button"
          labelText={Clear}
          buttonType="secondary-outline"
          customClass="btn__footer--clear"
          buttonIcon={<FaEraser className="btn__icon" />}
          disabled
        />
        <EpButton
          actionType="submit"
          labelText={Run}
          buttonType="primary"
          customClass="btn__footer--run"
          buttonIcon={<FaCheck className="btn__icon" />}
          disabled={false}
        />
      </div>
    </>
  );

  return (
    <EpModalStick modalStickId={modalStickId} buttonToggleId={buttonToggleId} size="sm" headerTitle={Columns} bodyContent={bodyContent} footerContent={footerContent ? footerContentSm : null} headerContent={headerContent} />
  );
};

export default EpModalStickColumns;

EpModalStickColumns.defaultProps = {
  headerContent: null,
  footerContent: null,
};

EpModalStickColumns.propTypes = {
  bodyContent: PropTypes.element.isRequired,
  headerContent: PropTypes.element,
  footerContent: PropTypes.bool,
  modalStickId: PropTypes.string.isRequired,
  buttonToggleId: PropTypes.string.isRequired,
};
